module.exports = __webpack_public_path__ + "img/no_user_photo.0fccfed3.jpg";